import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum SelfDescription {
  DietAndTrainingNeedWork = 'DietAndTraining',
  StruggleConsistency = 'Consistency',
  SlowProgress = 'SlowProgress', 
}

const describeSelfQuestion = {
  name: "describeSelf",
  title: loc("quiz.describeSelf.title"),
  description: loc("quiz.describeSelf.description"),
  type: "radiogroup",
  choices: [
    {
      value: SelfDescription.DietAndTrainingNeedWork,
      text: locIconButton("quiz.describeSelf.choices.scratch", "🐣"),
    },
    {
      value: SelfDescription.StruggleConsistency,
      text: locIconButton("quiz.describeSelf.choices.inconsistent", "🌤️"),
    },
    {
      value: SelfDescription.SlowProgress,
      text: locIconButton("quiz.describeSelf.choices.stuck", "🐢"),
    },
  ],
  isRequired: true,
};

export {
  SelfDescription,
  describeSelfQuestion,
}